var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Output, EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { UsuarioService } from '../../services/usuario.service';
import { CommonService } from '../../services/common.service';
import { KeycloakService } from '../../services/keycloak.service';
import { ExpedienteService } from '../../services/expediente.service';
import { ActuacionService } from '../../services/actuacion.service';
import { WebSocketService } from '../../services/websocket.service';
import { SharedService } from '../../services/shared.service';
var ExpedienteDownloadComponent = (function () {
    function ExpedienteDownloadComponent(_usrService, _expService, _actService, builder, _comService, _service, _ws) {
        this._usrService = _usrService;
        this._expService = _expService;
        this._actService = _actService;
        this.builder = builder;
        this._comService = _comService;
        this._service = _service;
        this._ws = _ws;
        this.onClose = new EventEmitter(false);
        this.onRefresh = new EventEmitter(false);
        this.visible = false;
        this.isDisabled = false;
        this.selectedDacs = [];
        this.selectedDacsExcluir = [];
        //selectedPartes: Parte[] = [];
        //parteList: Parte[];
        this.selectedFirmantes = [];
        this.selectedFirmantessExcluir = [];
        this.desActList = [
            { "id": 0, "descr": "EXPEDIENTE Y ACUMULADO" },
            { "id": 1, "descr": "SIN ACUMULADO" },
            { "id": 2, "descr": "SOLO ACUMULADO" }
        ];
        this.conAdjunto = false;
        this.descargaZip = false;
        this.conEscrito = false; //solo escritos incorporados al expediente
        this.tieneAcum = true;
        this.desActSeleccionado = 0;
        this.usarDescargaExpWS = false; //en true utiliza websocket en la descarga del expediente
        this.sessionId = "";
        this.uuidDescargaThread = "";
        this.fileName = "";
        this.downloadFilter = { expId: 0, fecha_desde: "", fecha_hasta: "", dac: [], firmante: [], descarga_act: 0, con_adjuntos: false, descarga_zip: false, con_escritos: false, fecha_desde_excluir: "", fecha_hasta_excluir: "", dac_excluir: [], firmante_excluir: [], usrCod: "" };
        //this.instanceId = Math.floor(Math.random() * 1000000);
    }
    ExpedienteDownloadComponent.prototype.ngOnInit = function () {
        this.hideErrorMsg();
        //console.log("expediente "+JSON.stringify(this.expediente));
        this.usarDescargaExpWS = this._comService.getConfiguracion('DEXPASYNC') == 'true';
        //this.connectWS();
    };
    ExpedienteDownloadComponent.prototype.ngOnDestroy = function () {
        if (this.messageSubscription) {
            this.messageSubscription.unsubscribe();
            //console.log("Desuscrito de los mensajes del WebSocket");
        }
        // Desconectar el WebSocket si es necesario
        //console.log("ngOnDestroy desconectar el WebSocket");
        this._ws.disconnect();
        this._ws = null;
    };
    ExpedienteDownloadComponent.prototype.connectWS = function () {
        var _this = this;
        // URL del WebSocket
        var wsUrl = SharedService.getProp("services_url")
            .replace("/api/", "/")
            .replace("http", "ws") + "manager-websocket";
        //console.log("url ws " + wsUrl);
        //console.log("Estableciendo conexion con el ws");
        this._ws.connect(wsUrl);
        this._ws.onOpen.subscribe(function () {
            //console.log("Conexión WebSocket establecida");
        });
        this.messageSubscription = this._ws.onMessage.subscribe(function (response) {
            //console.log("Mensaje recibido del ws: " + JSON.stringify(response));
            _this.processMessage(response);
        });
        // Manejar cierre de conexión (aún no se cierra)
        this._ws.onClose.subscribe(function () {
            //console.log("Conexión ws cerrada");
            _this._service.emitBlocking(false);
        });
        // Manejar errores del WebSocket
        this._ws.onError.subscribe(function (error) {
            //console.log("Error en ws");
            alert("Ha ocurrido un problema con el WebSocket");
            _this._ws.disconnect();
            _this._service.emitBlocking(false);
        });
    };
    ExpedienteDownloadComponent.prototype.findDacByExp = function () {
        var _this = this;
        this._comService.emitBlocking(true);
        this._actService.findDacByExp(this.expediente.expId).subscribe(function (response) {
            _this.dacList = response;
            _this.selectedDacs = _this.dacList.slice();
            _this._comService.emitBlocking(false);
        });
    };
    /*
    findPartes() {
        this._expService.findPartes(this.expediente.expId).subscribe(response => {
            this.parteList = response;
            this.selectedPartes = this.parteList.slice()
        });
    }
    */
    ExpedienteDownloadComponent.prototype.findFirmantesByExp = function () {
        var _this = this;
        this._comService.emitBlocking(true);
        this._actService.findFirmantesByExp(this.expediente.expId).subscribe(function (response) {
            _this.firmanteList = response;
            _this.selectedFirmantes = _this.firmanteList.slice();
            _this._comService.emitBlocking(false);
        });
    };
    ExpedienteDownloadComponent.prototype.tieneAcumulado = function () {
        var _this = this;
        this._expService.tieneAcumulado(this.expediente.expId).subscribe(function (response) {
            _this.tieneAcum = response;
        });
    };
    ExpedienteDownloadComponent.prototype.openPopup = function (exp) {
        //console.log("instancia de download " + this.instanceId);
        //console.log("openPopup descarg exediente" + JSON.stringify(exp));
        this.hideErrorMsg();
        this.expediente = exp;
        this.hideErrorMsg();
        this.visible = true;
        this.tieneAcumulado();
        this.findDacByExp();
        //this.findPartes();
        this.findFirmantesByExp();
        this.onClickConEscrito(null);
    };
    ExpedienteDownloadComponent.prototype.finalize = function () {
        this.hideErrorMsg();
        this.downloadFilter = { expId: 0, fecha_desde: "", fecha_hasta: "", dac: [], firmante: [], descarga_act: 0, con_adjuntos: false, descarga_zip: false, con_escritos: false, fecha_desde_excluir: "", fecha_hasta_excluir: "", dac_excluir: [], firmante_excluir: [], usrCod: "" };
        this.selectedDacs = [];
        this.selectedDacsExcluir = [];
        this.selectedFirmantes = [];
        this.selectedFirmantessExcluir = [];
        this.conAdjunto = false;
        this.descargaZip = false;
        this.conEscrito = false;
        this.tieneAcum = true;
        this.desActSeleccionado = 0;
        this.destroyWS();
        this.onClose.emit(1);
    };
    ExpedienteDownloadComponent.prototype.onClickDownload = function () {
        //console.log("onclickdownload");
        this.hideErrorMsg();
        if (this.validateDate()) {
            this.setDownloadFilter();
            //console.log("downloadFilter: " + JSON.stringify(this.downloadFilter));
            this._comService.emitBlocking(true);
            this.fileName = "expediente_" + this.expediente.numero;
            if (this.usarDescargaExpWS) {
                //webSocket
                this.connectWS();
            }
            else {
                //console.log("llamando al servicio");
                if (this.descargaZip) {
                    this.downloadExpZIP();
                }
                else {
                    this.downloadExpPDF();
                }
            }
        }
    };
    ExpedienteDownloadComponent.prototype.validateDate = function () {
        var fechaDesde;
        var fechaHasta;
        var fechaDesdeE;
        var fechaHastaE;
        if (this.downloadFilter.fecha_desde && this.downloadFilter.fecha_hasta) {
            fechaDesde = new Date(this.downloadFilter.fecha_desde);
            fechaHasta = new Date(this.downloadFilter.fecha_hasta);
            if (fechaDesde > fechaHasta) {
                this.showErrorMessage("La fecha de firmado hasta debe ser mayor o igual que la fecha de firmado desde.");
                return false;
            }
            else {
                if (this.downloadFilter.fecha_desde_excluir && this.downloadFilter.fecha_hasta_excluir) {
                    fechaDesdeE = new Date(this.downloadFilter.fecha_desde_excluir);
                    fechaHastaE = new Date(this.downloadFilter.fecha_hasta_excluir);
                    if (fechaDesdeE < fechaDesde || fechaHastaE > fechaHasta) {
                        this.showErrorMessage("Las fechas a excluir deben estar dentro del rango de la fecha de firmado desde y la fecha de firmado hasta.");
                        return false;
                    }
                    else {
                        if (fechaDesdeE > fechaHastaE) {
                            this.showErrorMessage("La fecha de firmado hasta debe ser mayor o igual que la fecha de firmado desde.");
                            return false;
                        }
                    }
                }
            }
        }
        else {
            if (this.downloadFilter.fecha_desde_excluir && this.downloadFilter.fecha_hasta_excluir) {
                fechaDesdeE = new Date(this.downloadFilter.fecha_desde_excluir);
                fechaHastaE = new Date(this.downloadFilter.fecha_hasta_excluir);
                if (fechaDesdeE > fechaHastaE) {
                    this.showErrorMessage("La fecha de firmaeo hasta debe ser mayor o igual que la fecha de firmado desde.");
                    return false;
                }
            }
        }
        return true;
    };
    ExpedienteDownloadComponent.prototype.setDownloadFilter = function () {
        this.downloadFilter.expId = this.expediente.expId;
        this.downloadFilter.dac = this.selectedDacs;
        this.downloadFilter.firmante = this.selectedFirmantes;
        this.downloadFilter.descarga_act = this.desActSeleccionado;
        this.downloadFilter.con_adjuntos = this.conAdjunto;
        this.downloadFilter.descarga_zip = this.descargaZip;
        this.downloadFilter.con_escritos = this.conEscrito;
        this.downloadFilter.dac_excluir = this.selectedDacsExcluir;
        this.downloadFilter.firmante_excluir = this.selectedFirmantessExcluir;
        this.downloadFilter.usrCod = KeycloakService.getLoggedUser();
    };
    ExpedienteDownloadComponent.prototype.downloadExpZIP = function () {
        var _this = this;
        this._expService.downloadExpZIP(JSON.stringify(this.downloadFilter)).subscribe(function (res) {
            //console.log("downloadFilter: " + JSON.stringify(res));
            _this._comService.emitBlocking(false);
            _this.downloadFile(res, _this.fileName);
            _this.finalize();
        }, function (error) {
            _this._comService.emitBlocking(false);
            alert("No se pudo generar el ZIP");
            _this.finalize();
        });
    };
    ExpedienteDownloadComponent.prototype.downloadExpPDF = function () {
        var _this = this;
        this._expService.downloadExpPDF(JSON.stringify(this.downloadFilter)).subscribe(function (res) {
            //console.log("downloadFilter: " + JSON.stringify(res));
            _this._comService.emitBlocking(false);
            _this.downloadFile(res, _this.fileName);
            _this.finalize();
        }, function (error) {
            _this._comService.emitBlocking(false);
            alert("No se pudo generar el PDF");
            _this.finalize();
        });
    };
    ExpedienteDownloadComponent.prototype.downloadExpZIPThread = function () {
        var _this = this;
        this._expService.downloadExpZIPThread(JSON.stringify(this.downloadFilter), this.sessionId).subscribe(function (res) {
            //console.log("respuesta downloadExpThread " + res);
            if (res) {
                _this.uuidDescargaThread = res;
            }
            else {
                _this._comService.emitBlocking(false);
                alert("No se pudo generar el ZIP");
                _this.finalize();
            }
        }, function (error) {
            _this._comService.emitBlocking(false);
            alert("No se pudo generar el ZIP");
            _this.finalize();
        });
    };
    ExpedienteDownloadComponent.prototype.downloadExpPDFThread = function () {
        var _this = this;
        this._expService.downloadExpPDFThread(JSON.stringify(this.downloadFilter), this.sessionId).subscribe(function (res) {
            //console.log("respuesta downloadExpThread " + res);
            if (res) {
                _this.uuidDescargaThread = res;
            }
            else {
                _this._comService.emitBlocking(false);
                alert("No se pudo generar el PDF");
                _this.finalize();
            }
        }, function (error) {
            _this._comService.emitBlocking(false);
            alert("No se pudo generar el PDF");
            _this.finalize();
        });
    };
    ExpedienteDownloadComponent.prototype.getResultadoDescargaExpedienteZIP = function () {
        var _this = this;
        if (this.uuidDescargaThread != null && this.uuidDescargaThread != "") {
            this._expService.getResultadodownloadExpZIPThread(this.uuidDescargaThread).subscribe(function (res) {
                _this._comService.emitBlocking(false);
                _this.downloadFile(res, _this.fileName);
                _this.finalize();
            }, function (error) {
                _this._comService.emitBlocking(false);
                alert("No se pudo generar el ZIP");
                _this.finalize();
            });
        }
    };
    ExpedienteDownloadComponent.prototype.getResultadoDescargaExpedientePDF = function () {
        var _this = this;
        if (this.uuidDescargaThread != null && this.uuidDescargaThread != "") {
            this._expService.getResultadodownloadExpPDFThread(this.uuidDescargaThread).subscribe(function (res) {
                _this._comService.emitBlocking(false);
                _this.downloadFile(res, _this.fileName);
                _this.finalize();
            }, function (error) {
                _this._comService.emitBlocking(false);
                alert("No se pudo generar el PDF");
                _this.finalize();
            });
        }
    };
    ExpedienteDownloadComponent.prototype.downloadFile = function (blob, fileName) {
        var _this = this;
        //console.log("downloadFile" + fileName);
        var contentType = this.descargaZip ? 'application/zip' : 'application/pdf';
        var a = document.createElement("a");
        document.body.appendChild(a);
        var file = new Blob([blob], { type: contentType });
        var fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = fileName + (this.descargaZip ? '.zip' : '.pdf');
        a.addEventListener('click', function () {
            $('#expediente-download-' + _this.instanceId).modal('hide'); // Oculta la ventana modal
        });
        a.click();
    };
    ExpedienteDownloadComponent.prototype.processMessage = function (event) {
        //console.log("Mensaje recibido del ws: " + event.data);
        //console.log("Mensaje event " + JSON.stringify(event));
        var message = event.command;
        switch (message) {
            case 'init':
                //console.log("sessionId: " + event.data);
                this.sessionId = event.data;
                //console.log("sessionId: " + this.sessionId);
                //console.log("desccarga del expediente: " + this.sessionId);
                if (this.descargaZip) {
                    this.downloadExpZIPThread();
                }
                else {
                    this.downloadExpPDFThread();
                }
                break;
            case 'finDescargaPersonalizadaExpedientePDFThread':
                //console.log("Proceso descarga expediente PDF finalizado");
                this.getResultadoDescargaExpedientePDF();
                break;
            case 'finDescargaPersonalizadaExpedienteZIPThread':
                //console.log("Proceso descarga expediente ZIP finalizado");
                this.getResultadoDescargaExpedienteZIP();
                break;
            case 'errorDescargaPersonalizadaExpedienteThread':
                //console.log("Error proceso de descarga de expediente");
                this._comService.emitBlocking(false);
                alert('Ocurrió un error en el proceso de descarga de expediente.');
                this.finalize();
                break;
            default:
        }
    };
    ExpedienteDownloadComponent.prototype.onClickCancelar = function () {
        this.hideErrorMsg();
        this.downloadFilter = { expId: 0, fecha_desde: "", fecha_hasta: "", dac: [], firmante: [], descarga_act: 0, con_adjuntos: false, descarga_zip: false, con_escritos: false, fecha_desde_excluir: "", fecha_hasta_excluir: "", dac_excluir: [], firmante_excluir: [], usrCod: "" };
        this.selectedDacs = [];
        this.selectedDacsExcluir = [];
        this.selectedFirmantes = [];
        this.selectedFirmantessExcluir = [];
        this.conAdjunto = false;
        this.descargaZip = false;
        this.conEscrito = false;
        this.tieneAcum = true;
        this.desActSeleccionado = 0;
        this.onClose.emit(1);
    };
    ExpedienteDownloadComponent.prototype.showErrorMessage = function (msg) {
        this.ErrorMsg = msg;
        this.ErrorMessageIsVisible = true;
    };
    ExpedienteDownloadComponent.prototype.showSuccessMessage = function (msg) {
        this.SuccessMsg = msg;
        this.SuccessMessageIsVisible = true;
    };
    ExpedienteDownloadComponent.prototype.hideErrorMsg = function () {
        this.isDisabled = false;
        document.getElementById("_printButton").hidden = false;
        this.ErrorMsg = "";
        this.ErrorMessageIsVisible = false;
        this.hideSuccessMsg();
    };
    ExpedienteDownloadComponent.prototype.hideSuccessMsg = function () {
        this.SuccessMsg = "";
        this.SuccessMessageIsVisible = false;
    };
    ExpedienteDownloadComponent.prototype.onChangeDate = function () {
        this.downloadFilter.fecha_hasta = this.downloadFilter.fecha_desde;
    };
    ExpedienteDownloadComponent.prototype.toggleOptionDac = function (dac) {
        var index = this.selectedDacs.indexOf(dac);
        if (index === -1) {
            this.selectedDacs.push(dac);
        }
        else {
            this.selectedDacs.splice(index, 1);
        }
    };
    ExpedienteDownloadComponent.prototype.isSelectedDac = function (dac) {
        return this.selectedDacs.indexOf(dac) !== -1;
    };
    /*
    toggleOptionParte(p: Parte): void {
        const index = this.selectedPartes.findIndex((selectedParte) => selectedParte.parte === p.parte);
    
        if (index === -1) {
          this.selectedPartes.push(p);
        } else {
          this.selectedPartes.splice(index, 1);
        }
    }
    
    isSelectedParte(p: Parte): boolean {
        return this.selectedPartes.findIndex((selectedParte) => selectedParte.parte === p.parte) !== -1;
    }
    */
    ExpedienteDownloadComponent.prototype.toggleOptionFirmante = function (fir) {
        var index = this.selectedFirmantes.indexOf(fir);
        if (index === -1) {
            this.selectedFirmantes.push(fir);
        }
        else {
            this.selectedFirmantes.splice(index, 1);
        }
    };
    ExpedienteDownloadComponent.prototype.isSelectedFirmante = function (fir) {
        return this.selectedFirmantes.indexOf(fir) !== -1;
    };
    ExpedienteDownloadComponent.prototype.onClickConAdjunto = function (ev) {
        this.conAdjunto = !this.conAdjunto;
        if (this.conAdjunto) {
            this.descargaZip = true;
        }
    };
    ExpedienteDownloadComponent.prototype.onClickDescargaZip = function (ev) {
        this.descargaZip = !this.descargaZip;
        if (!this.descargaZip) {
            this.conAdjunto = false;
        }
    };
    ExpedienteDownloadComponent.prototype.onClickConEscrito = function (ev) {
        this.conEscrito = !this.conEscrito;
    };
    ExpedienteDownloadComponent.prototype.onChangeDateExcluir = function () {
        this.downloadFilter.fecha_hasta_excluir = this.downloadFilter.fecha_desde_excluir;
    };
    ExpedienteDownloadComponent.prototype.toggleOptionDacExcluir = function (dac) {
        var index = this.selectedDacsExcluir.indexOf(dac);
        if (index === -1) {
            this.selectedDacsExcluir.push(dac);
        }
        else {
            this.selectedDacsExcluir.splice(index, 1);
        }
    };
    ExpedienteDownloadComponent.prototype.isSelectedDacExcluir = function (dac) {
        return this.selectedDacsExcluir.indexOf(dac) !== -1;
    };
    ExpedienteDownloadComponent.prototype.toggleOptionFirmanteExcluir = function (fir) {
        var index = this.selectedFirmantessExcluir.indexOf(fir);
        if (index === -1) {
            this.selectedFirmantessExcluir.push(fir);
        }
        else {
            this.selectedFirmantessExcluir.splice(index, 1);
        }
    };
    ExpedienteDownloadComponent.prototype.isSelectedFirmanteExcluir = function (fir) {
        return this.selectedFirmantessExcluir.indexOf(fir) !== -1;
    };
    ExpedienteDownloadComponent.prototype.onChangeSelectDesAct = function (desAct) {
        this.desActSeleccionado = desAct;
    };
    ExpedienteDownloadComponent.prototype.destroyWS = function () {
        if (this.messageSubscription) {
            this.messageSubscription.unsubscribe();
            //console.log("Desuscrito de los mensajes del WebSocket");
        }
        // Desconectar el WebSocket si es necesario
        //console.log("ngOnDestroy desconectar el WebSocket");
        this._ws.disconnect();
        //this._ws = null;
    };
    return ExpedienteDownloadComponent;
}());
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], ExpedienteDownloadComponent.prototype, "onClose", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], ExpedienteDownloadComponent.prototype, "onRefresh", void 0);
ExpedienteDownloadComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'expediente-download',
        templateUrl: 'expediente-download.component.html'
    }),
    __metadata("design:paramtypes", [UsuarioService,
        ExpedienteService,
        ActuacionService,
        FormBuilder,
        CommonService,
        CommonService,
        WebSocketService])
], ExpedienteDownloadComponent);
export { ExpedienteDownloadComponent };
//# sourceMappingURL=expediente-download.component.js.map